module.exports = __webpack_public_path__ + "media/images/area/icon_weather_19-6e072bf44e88fcbd03f79a64e40ca93f.png";